import { useCallback, useEffect, useState } from "react"
import { config } from "../../tools/config/singleProcessData";
import LoadingSpinner from "../../components/Visuals";
import MarketSortableTable from "../../components/MarketSortableTable";
import getUrl from "../../tools/get-domain";

function MarketRealTimeSinglePage() {
    const [stockList, setStockList] = useState([])
    const [isLoading, setLoading] = useState(false)

    const fetchData = useCallback(async () => {
        const fetchUrl = getUrl().REACT_APP_MARKET_REALTIME_SYMBOLS
        const response = await fetch(fetchUrl)
        const symbolList = await response.json()

        setStockList(symbolList)
        setLoading(false)
    }, [])


    useEffect(() => {
        setLoading(true)
        fetchData()
    }, [fetchData])

    return (
        <div className="content flex-row-fluid" id="kt_content" dir="rtl">
            <div className="container-fluid mt-lg-0 mt-5">
                <div className="row">
                    <div className="col-xl-12 d-block">
                        <div className="h-100">
                            {isLoading ?
                                <LoadingSpinner /> :
                                <MarketSortableTable config={config} rows={stockList} single />
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MarketRealTimeSinglePage